// Phase 36 Batch AM — PostHog event helpers for property discovery.
//
// Each helper wraps `window.posthog?.capture?.(...)` in a try/catch so the
// site keeps working when PostHog is blocked / not loaded. Event names
// are stable; payload keys must match the spec in PRD.md.

function _capture(name, props = {}) {
  try {
    if (typeof window === "undefined") return;
    window.posthog?.capture?.(name, props);
  } catch {
    /* PostHog blocked or not loaded — ignore */
  }
}

export function trackSearchCreated({ filter_count, location_type, has_email_digest }) {
  _capture("discovery_search_created", { filter_count, location_type, has_email_digest });
}

export function trackSearchEdited({ search_id }) {
  _capture("discovery_search_edited", { search_id });
}

export function trackSearchDeleted({ search_id }) {
  _capture("discovery_search_deleted", { search_id });
}

export function trackSearchRun({ search_id, match_count, source }) {
  _capture("discovery_search_run", { search_id, match_count, source });
}

export function trackListingViewed({ listing_id, cap_rate, cash_flow }) {
  _capture("discovery_listing_viewed", { listing_id, cap_rate, cash_flow });
}

export function trackListingImported({ listing_id, deal_id_created }) {
  _capture("discovery_listing_imported_to_deal", { listing_id, deal_id_created });
}

export function trackQuotaWarning({ remaining_calls }) {
  _capture("discovery_quota_warning_shown", { remaining_calls });
}
